// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
//   import Layout from './Layout/Layout';
// import API_URL from '../Config';
// import 'react-toastify/dist/ReactToastify.css';
// import { Client } from "@stomp/stompjs";
// import SockJS from "sockjs-client";
// import '../css/WebLiveCss.css';
// import {
//   Users,
//   Clock3,
//   ShieldCheck,
//   LogOut,
//   Volume2,
//   VolumeX,
//   Play,
//   Pause,
//   Maximize,
//   Settings,
//   PictureInPicture2
// } from "lucide-react";

// const WebLive = () => {
//     const navigate = useNavigate();
//     const videoRef = useRef(null);

//     const { id } = useParams();

//     // All useState hooks must be at the top
//     const [stream, setStream] = useState(null);
//     const [error, setError] = useState("");

//     const [isPlaying, setIsPlaying] = useState(false);
//     const [isMuted, setIsMuted] = useState(false);
//     const [volume, setVolume] = useState(70);
//     const [viewerCount, setViewerCount] = useState(0);
//     const [elapsedMinutes, setElapsedMinutes] = useState(0);

//     // Fetch stream details
//     useEffect(() => {

//         const fetchStream = async () => {

//             try {
//                 const response = await axios.get(
//                     `http://localhost:8080/api/streams/get/${id}`
//                 );

//                 console.log("Stream details:", response.data);

//                 setStream(response.data);
//                 setError("");

//             } catch (err) {
//                 console.error("Error fetching stream:", err);
//                 setError("Unable to load live stream.");
//             }
//         };

//         fetchStream();

//     }, [id]);

//     // Calculate elapsed time
//     useEffect(() => {

//         if (!stream?.scheduledStart) {
//             return;
//         }

//         const updateElapsed = () => {

//             const startTime = new Date(stream.scheduledStart);

//             if (Number.isNaN(startTime.getTime())) {
//                 setElapsedMinutes(0);
//                 return;
//             }

//             const minutes = Math.max(
//                 0,
//                 Math.floor(
//                     (Date.now() - startTime.getTime()) / 60000
//                 )
//             );

//             setElapsedMinutes(minutes);
//         };

//         updateElapsed();

//         const interval = setInterval(updateElapsed, 60000);

//         return () => clearInterval(interval);

//     }, [stream?.scheduledStart]);

//     // Play / Pause
//     const togglePlay = async () => {

//         const video = videoRef.current;

//         if (!video) return;

//         try {
//             if (video.paused) {
//                 await video.play();
//             } else {
//                 video.pause();
//             }
//         } catch (error) {
//             console.error("Video playback failed:", error);
//         }
//     };

//     // Mute / Unmute
//     const toggleMute = () => {

//         const video = videoRef.current;

//         if (!video) return;

//         video.muted = !video.muted;

//         setIsMuted(video.muted);
//     };

//     // Volume control
//     const handleVolume = (event) => {

//         const value = Number(event.target.value);

//         setVolume(value);

//         if (videoRef.current) {
//             videoRef.current.volume = value / 100;
//             videoRef.current.muted = value === 0;
//             setIsMuted(value === 0);
//         }
//     };

//     // Fullscreen
//     const handleFullscreen = () => {

//         const player = document.querySelector(".mj-live-player");

//         if (player?.requestFullscreen) {
//             player.requestFullscreen();
//         }
//     };

//     // Picture in Picture
//     const handlePictureInPicture = async () => {

//         const video = videoRef.current;

//         if (!video || !document.pictureInPictureEnabled) {
//             return;
//         }

//         try {
//             if (document.pictureInPictureElement) {
//                 await document.exitPictureInPicture();
//             } else {
//                 await video.requestPictureInPicture();
//             }
//         } catch (error) {
//             console.error("Picture-in-picture failed:", error);
//         }
//     };

//     // Leave live stream
//     const handleLeaveLive = () => {

//         videoRef.current?.pause();

//         navigate("/live-streams");
//     };

//     // Conditional returns must come AFTER all hooks
//     if (error) {
//         return <p>{error}</p>;
//     }

//     if (!stream) {
//         return <p>Loading live stream...</p>;
//     }


//   return (
//     <Layout>
//     <div className="mj-live-page">
//       <div className="mj-live-container">

//         {/* VIDEO PLAYER */}
//         <div className="mj-live-player">

//           <video
//             ref={videoRef}
//             className="mj-live-video"
//             // src={stream.videoUrl || undefined}
//             // poster="/images/live-poster.jpg"
//             playsInline
//             onPlay={() => setIsPlaying(true)}
//             onPause={() => setIsPlaying(false)}
//           />

//           {/* TOP BADGES */}
//           <div className="mj-live-top-badges">
//             <span className="mj-live-badge">
//               <span className="mj-live-dot"></span>
//               LIVE
//             </span>

//             <span className="mj-viewer-badge">
//               <Users size={20} fill="white" />
//               {viewerCount} watching
//             </span>
//           </div>

//           {/* PLAYER CONTROLS */}
//           <div className="mj-player-controls">

//             <div className="mj-player-left">
//               <button
//                 className="mj-player-btn"
//                 onClick={togglePlay}
//                 aria-label={isPlaying ? "Pause" : "Play"}
//               >
//                 {isPlaying ? <Pause fill="white" /> : <Play fill="white" />}
//               </button>

//               <button
//                 className="mj-player-btn"
//                 onClick={toggleMute}
//                 aria-label={isMuted ? "Unmute" : "Mute"}
//               >
//                 {isMuted ? <VolumeX /> : <Volume2 />}
//               </button>

//               <input
//                 type="range"
//                 min="0"
//                 max="100"
//                 value={volume}
//                 onChange={handleVolume}
//                 className="mj-volume-slider"
//                 aria-label="Volume"
//               />
//             </div>

//             <div className="mj-player-right">
//               <button className="mj-player-btn" title="Settings">
//                 <Settings />
//               </button>

//               <button
//                 className="mj-player-btn"
//                 onClick={handlePictureInPicture}
//                 title="Picture in Picture"
//               >
//                 <PictureInPicture2 />
//               </button>

//               <button
//                 className="mj-player-btn"
//                 onClick={handleFullscreen}
//                 title="Fullscreen"
//               >
//                 <Maximize />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* STREAM INFORMATION */}
//         <div className="mj-stream-info">

//           <div className="mj-stream-details">
//             <h1>{stream.title}</h1>
//             <p>{stream.description}</p>

//             <div className="mj-stream-tags">
//               {/* <span>{stream.category}</span> */}

//               {/* {stream.tags.map((tag, index) => (
//                 <span key={index}>{tag}</span>
//               ))} */}
//             </div>
//           </div>

//           <div className="mj-stream-stats">
//             <div className="mj-stat">
//               <Users size={25} fill="white" />
//               <span>{viewerCount} watching</span>
//             </div>

//             <div className="mj-stat-divider"></div>

//             <div className="mj-stat">
//               <Clock3 size={25} />
//               <span>Started {elapsedMinutes} min ago</span>
//             </div>
//           </div>
//         </div>

//         {/* VIEW ONLY INFORMATION */}
//         <div className="mj-view-only-card">

//           <div className="mj-view-only-left">
//             <div className="mj-shield">
//               <ShieldCheck size={36} />
//             </div>

//             <div className="mj-view-only-text">
//               <h3>View-only mode</h3>
//               <p>
//                 You can watch and listen to the live stream.
//                 Interaction is disabled.
//               </p>
//             </div>
//           </div>

//           <button
//             className="mj-leave-btn"
//             onClick={handleLeaveLive}
//           >
//             <LogOut size={23} />
//             Leave Live
//           </button>
//         </div>

//       </div>
//     </div>
//     </Layout>
//   );

// };

// export default WebLive;



//original code


import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "./Layout/Layout";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import "../css/WebLiveCss.css";

import {
  Users,
  Clock3,
  ShieldCheck,
  LogOut,
  Volume2,
  VolumeX,
  Play,
  Pause,
  Maximize,
  Settings,
  PictureInPicture2
} from "lucide-react";

const BASE_URL = "http://localhost:8080";
const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];

const WebLive = () => {

  const { id } = useParams();
    const videoRef = useRef(null);
    const [status, setStatus] = useState('Loading...');
    const [error, setError] = useState('');
    const [count, setCount] = useState(0);
    const [muted, setMuted] = useState(true);
  
    useEffect(() => {
      let disposed = false;
      let client;
      let peer;
      let joined = false;
      const viewerId = crypto.randomUUID();
      const pendingIce = [];
      // Adapt this to your actual authenticated user ID source.
      const userId = Number(sessionStorage.getItem('userId'));
  
      const send = (type, payload = {}) => {
        if (!client?.connected) return;
        client.publish({
          destination: `/app/webrtc/${id}/signal`,
          body: JSON.stringify({ type, from: viewerId, target: 'admin', ...payload })
        });
      };
  
      const handleSignal = async msg => {
        if (!peer || disposed) return;
        if (msg.type === 'offer') {
          await peer.setRemoteDescription(new RTCSessionDescription(msg.sdp));
          for (const candidate of pendingIce.splice(0)) {
            await peer.addIceCandidate(new RTCIceCandidate(candidate));
          }
          const answer = await peer.createAnswer();
          await peer.setLocalDescription(answer);
          send('answer', { sdp: peer.localDescription });
        } else if (msg.type === 'ice' && msg.candidate) {
          if (peer.remoteDescription) await peer.addIceCandidate(new RTCIceCandidate(msg.candidate));
          else pendingIce.push(msg.candidate);
        }
      };
  
      const connect = async () => {
        try {
          const { data: stream } = await axios.get(`${BASE_URL}/api/streams/${id}`);
          if (disposed) return;
          if (stream.status !== 'LIVE') { setStatus(`Stream is ${stream.status}`); return; }
          setStatus('Connecting...');
          peer = new RTCPeerConnection({ iceServers });
          peer.addTransceiver('video', { direction: 'recvonly' });
          peer.addTransceiver('audio', { direction: 'recvonly' });
          const remoteStream = new MediaStream();
          peer.ontrack = ({ track }) => {
            if (!remoteStream.getTracks().some(t => t.id === track.id)) remoteStream.addTrack(track);
            if (videoRef.current) videoRef.current.srcObject = remoteStream;
          };
          peer.onconnectionstatechange = () => {
            if (!disposed) setStatus(peer.connectionState);
          };
          peer.onicecandidate = ({ candidate }) => {
            if (candidate) send('ice', { candidate: candidate.toJSON() });
          };
          client = new Client({
            webSocketFactory: () => new SockJS(`${BASE_URL}/ws-livestream`),
            reconnectDelay: 0,
            onConnect: async () => {
              client.subscribe(`/topic/webrtc/${id}/${viewerId}`, frame => {
                handleSignal(JSON.parse(frame.body)).catch(err => setError(err.message));
              });
              client.subscribe(`/topic/stream/${id}/viewer-count`, frame => {
                setCount(JSON.parse(frame.body).count);
              });
              client.subscribe(`/topic/stream/${id}/status`, frame => {
                const event = JSON.parse(frame.body);
                if (event.status === 'ENDED') { setStatus('Stream ended'); peer?.close(); }
              });
              try {
                if (!Number.isSafeInteger(userId) || userId <= 0) throw new Error('Valid logged-in userId is required');
                await axios.post(`${BASE_URL}/api/streams/${id}/viewers/join`, { userId, peerId: viewerId });
                joined = true;
                if (!disposed) send('join');
              } catch (err) { if (!disposed) setError(err.message); }
            },
            onStompError: frame => setError(frame.body || 'STOMP error'),
            onWebSocketError: () => setError('WebSocket error')
          });
          client.activate();
        } catch (err) { if (!disposed) setError(err.message); }
      };
      connect();
      return () => {
        disposed = true;
        send('leave');
        client?.deactivate();
        peer?.close();
        if (videoRef.current) videoRef.current.srcObject = null;
        if (joined) axios.post(`${BASE_URL}/api/streams/${id}/viewers/leave`, { peerId: viewerId }).catch(console.error);
      };
    }, [id]);
  const navigate = useNavigate();

  const playerRef = useRef(null);
  const peerRef = useRef(null);
  const stompRef = useRef(null);
  const remoteStreamRef = useRef(null);

  const [stream, setStream] = useState(null);
  const [connectionStatus, setConnectionStatus] =
    useState("Connecting...");

  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(70);
  const [viewerCount] = useState(null);
  const [elapsedMinutes, setElapsedMinutes] = useState(0);

  // STEP 1: Fetch stream details
  useEffect(() => {
    let active = true;

    const fetchStream = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/streams/get/${id}`
        );

        if (active) {
          setStream(response.data);
          setError("");
        }
      } catch (err) {
        console.error("Stream fetch error:", err);

        if (active) {
          setError("Unable to load live stream.");
        }
      }
    };

    if (id) {
      fetchStream();
    }

    return () => {
      active = false;
    };
  }, [id]);

  // STEP 2: Calculate elapsed time
  useEffect(() => {
    if (!stream?.scheduledStart) return;

    const updateElapsed = () => {
      const startTime = new Date(stream.scheduledStart);

      if (Number.isNaN(startTime.getTime())) {
        setElapsedMinutes(0);
        return;
      }

      const minutes = Math.max(
        0,
        Math.floor(
          (Date.now() - startTime.getTime()) / 60000
        )
      );

      setElapsedMinutes(minutes);
    };

    updateElapsed();

    const interval = setInterval(
      updateElapsed,
      60000
    );

    return () => clearInterval(interval);
  }, [stream?.scheduledStart]);

  // STEP 3: Connect to admin using WebRTC
  useEffect(() => {
    if (!id || stream?.status !== "LIVE") {
      return;
    }

    let disposed = false;
    let remoteDescriptionSet = false;

    const viewerId = crypto.randomUUID();
    const pendingIceCandidates = [];

    const remoteStream = new MediaStream();
    remoteStreamRef.current = remoteStream;

    const peer = new RTCPeerConnection({
      iceServers: [
        {
          urls: "stun:stun.l.google.com:19302"
        }
      ]
    });

    peerRef.current = peer;

    // User only receives video and audio
    peer.addTransceiver("video", {
      direction: "recvonly"
    });

    peer.addTransceiver("audio", {
      direction: "recvonly"
    });

    // Receive admin video/audio tracks
    peer.ontrack = (event) => {
      if (disposed) return;

      console.log("Received admin track:", event.track.kind);

      const trackExists = remoteStream
        .getTracks()
        .some(track => track.id === event.track.id);

      if (!trackExists) {
        remoteStream.addTrack(event.track);
      }

      if (videoRef.current) {
        videoRef.current.srcObject = remoteStream;
        videoRef.current.volume = volume / 100;

        videoRef.current.play().catch(err => {
          console.log(
            "Autoplay blocked. Click Play:",
            err
          );
        });
      }
    };

    peer.onconnectionstatechange = () => {
      if (disposed) return;

      console.log(
        "WebRTC connection:",
        peer.connectionState
      );

      switch (peer.connectionState) {
        case "connected":
          setConnectionStatus("Connected");
          break;

        case "connecting":
          setConnectionStatus("Connecting...");
          break;

        case "failed":
          setConnectionStatus("Connection failed");
          break;

        case "disconnected":
          setConnectionStatus("Disconnected");
          break;

        default:
          break;
      }
    };

    const client = new Client({
      webSocketFactory: () =>
        new SockJS(`${BASE_URL}/ws-livestream`),

      reconnectDelay: 0,

      onConnect: () => {
        if (disposed) return;

        console.log("Viewer WebSocket connected");

        // Subscribe to personal signaling channel
        client.subscribe(
          `/topic/webrtc/${id}/${viewerId}`,
          async (frame) => {
            if (disposed) return;

            try {
              const message = JSON.parse(frame.body);

              console.log(
                "Viewer received signal:",
                message.type
              );

              // Receive offer from admin
              if (message.type === "offer") {
                await peer.setRemoteDescription(
                  new RTCSessionDescription(message.sdp)
                );

                remoteDescriptionSet = true;

                // Add ICE candidates received before offer
                for (const candidate of pendingIceCandidates) {
                  await peer.addIceCandidate(
                    new RTCIceCandidate(candidate)
                  );
                }

                pendingIceCandidates.length = 0;

                // Create answer
                const answer = await peer.createAnswer();

                await peer.setLocalDescription(answer);

                // Send answer to admin
                client.publish({
                  destination:
                    `/app/webrtc/${id}/signal`,

                  body: JSON.stringify({
                    type: "answer",
                    from: viewerId,
                    target: "admin",
                    sdp: peer.localDescription
                  })
                });

                console.log("Answer sent to admin");
              }

              // Receive ICE candidate from admin
              if (
                message.type === "ice" &&
                message.candidate
              ) {
                if (remoteDescriptionSet) {
                  await peer.addIceCandidate(
                    new RTCIceCandidate(
                      message.candidate
                    )
                  );
                } else {
                  pendingIceCandidates.push(
                    message.candidate
                  );
                }
              }

            } catch (err) {
              console.error(
                "Viewer signaling error:",
                err
              );
            }
          }
        );

        // Send local ICE candidates to admin
        peer.onicecandidate = (event) => {
          if (
            event.candidate &&
            client.connected &&
            !disposed
          ) {
            client.publish({
              destination:
                `/app/webrtc/${id}/signal`,

              body: JSON.stringify({
                type: "ice",
                from: viewerId,
                target: "admin",
                candidate: event.candidate
              })
            });
          }
        };

        // Request admin video
        client.publish({
          destination: `/app/webrtc/${id}/signal`,

          body: JSON.stringify({
            type: "join",
            from: viewerId,
            target: "admin"
          })
        });

        setConnectionStatus(
          "Waiting for admin video..."
        );

        console.log(
          "Join request sent:",
          viewerId
        );
      },

      onStompError: (frame) => {
        if (!disposed) {
          console.error("STOMP error:", frame.body);
          setConnectionStatus(
            "WebSocket error"
          );
        }
      },

      onWebSocketError: (err) => {
        if (!disposed) {
          console.error("WebSocket error:", err);
          setConnectionStatus(
            "WebSocket disconnected"
          );
        }
      }
    });

    stompRef.current = client;
    client.activate();

    // Cleanup when user leaves
    return () => {
      disposed = true;

      peer.ontrack = null;
      peer.onicecandidate = null;
      peer.onconnectionstatechange = null;

      peer.close();
      client.deactivate();

      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }

      if (peerRef.current === peer) {
        peerRef.current = null;
      }

      if (stompRef.current === client) {
        stompRef.current = null;
      }

      remoteStreamRef.current = null;
    };
  }, [id, stream?.status]);

  // STEP 4: Video player controls
  const togglePlay = async () => {
    const video = videoRef.current;
    if (!video) return;

    try {
      if (video.paused) {
        await video.play();
      } else {
        video.pause();
      }
    } catch (err) {
      console.error("Playback error:", err);
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  const handleVolume = (event) => {
    const value = Number(event.target.value);

    setVolume(value);

    if (videoRef.current) {
      videoRef.current.volume = value / 100;
      videoRef.current.muted = value === 0;
      setIsMuted(value === 0);
    }
  };

  const handleFullscreen = async () => {
    const player = playerRef.current;

    if (!player) return;

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await player.requestFullscreen();
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  const handlePictureInPicture = async () => {
    const video = videoRef.current;

    if (
      !video ||
      !document.pictureInPictureEnabled
    ) {
      return;
    }

    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else {
        await video.requestPictureInPicture();
      }
    } catch (err) {
      console.error("PiP error:", err);
    }
  };

  const handleLeaveLive = () => {
    navigate("/live-streams");
  };

  // All hooks must be above conditional returns
  if (error) {
    return <p>{error}</p>;
  }

  if (!stream) {
    return <p>Loading live stream...</p>;
  }

  return (
    <Layout>
      <div className="mj-live-page">
        <div className="mj-live-container">

          {/* VIDEO PLAYER */}
          <div
            className="mj-live-player"
            ref={playerRef}
          >
            <video
              ref={videoRef}
              className="mj-live-video"
              autoPlay
              playsInline
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />

            {/* LIVE BADGES */}
            <div className="mj-live-top-badges">
              <span className="mj-live-badge">
                <span className="mj-live-dot"></span>
                {stream.status === "LIVE"
                  ? "LIVE"
                  : stream.status}
              </span>

              <span className="mj-viewer-badge">
                <Users size={20} />
                {count === null
                  ? "Viewers unavailable"
                  : `${count} watching`}
              </span>
            </div>

            {/* CONNECTION STATUS */}
            <div
              style={{
                position: "absolute",
                top: 55,
                left: 15,
                color: "white",
                fontSize: 13,
                background: "rgba(0,0,0,0.6)",
                padding: "5px 10px",
                borderRadius: 5
              }}
            >
              {/* {connectionStatus} */}
              <video ref={videoRef} autoPlay playsInline muted={muted} />
            </div>

            {/* PLAYER CONTROLS */}
            <div className="mj-player-controls">

              <div className="mj-player-left">

                <button
                  className="mj-player-btn"
                  onClick={togglePlay}
                  title="Play / Pause"
                >
                  {isPlaying
                    ? <Pause fill="white" />
                    : <Play fill="white" />}
                </button>

                <button
                  className="mj-player-btn"
                  onClick={toggleMute}
                  title="Mute / Unmute"
                >
                  {isMuted
                    ? <VolumeX />
                    : <Volume2 />}
                </button>

                <input
                  type="range"
                  min="0"
                  max="100"
                  value={volume}
                  onChange={handleVolume}
                  className="mj-volume-slider"
                />
              </div>

              <div className="mj-player-right">

                <button
                  className="mj-player-btn"
                  title="Settings"
                >
                  <Settings />
                </button>

                <button
                  className="mj-player-btn"
                  onClick={handlePictureInPicture}
                  title="Picture in Picture"
                >
                  <PictureInPicture2 />
                </button>

                <button
                  className="mj-player-btn"
                  onClick={handleFullscreen}
                  title="Fullscreen"
                >
                  <Maximize />
                </button>

              </div>
            </div>
          </div>

          {/* STREAM INFORMATION */}
          <div className="mj-stream-info">

            <div className="mj-stream-details">
              <h1>{stream.title}</h1>
              <p>{stream.description}</p>
            </div>

            <div className="mj-stream-stats">

              <div className="mj-stat">
                <Users size={25} />
                <span>
                  {count === null
                    ? "Viewers unavailable"
                    : `${count} watching`}
                </span>
              </div>

              <div className="mj-stat-divider" />

              <div className="mj-stat">
                <Clock3 size={25} />
                <span>
                  Started {elapsedMinutes} min ago
                </span>
              </div>

            </div>
          </div>

          {/* VIEW ONLY INFORMATION */}
          <div className="mj-view-only-card">

            <div className="mj-view-only-left">

              <div className="mj-shield">
                <ShieldCheck size={36} />
              </div>

              <div className="mj-view-only-text">
                <h3>View-only mode</h3>
                <p>
                  You can watch and listen to the
                  live stream. Interaction is disabled.
                </p>
              </div>
            </div>

            <button
              className="mj-leave-btn"
              onClick={handleLeaveLive}
            >
              <LogOut size={23} />
              Leave Live
            </button>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WebLive;


